import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import Modal from "../../components/Modal";
import BodyText from "../../elements/body-text";
import Checkbox from "../../elements/checkbox";
import Heading from "../../elements/heading";
import PrimaryButton from "../../elements/primary-button";
import "./style.scss";

const CookieSettings = ({ heading, body, sections = [], acceptAllButton = { callback: () => {} }, saveButton = { callback: () => {} }, showCookieModal }) => {
  const [settings, setSettings] = useState(sections);
  useEffect(() => {
    openRegionModal();
  }, [showCookieModal]);
  const selectAll = () => {
    const allSelectedSettings = settings.map(setting => {
      setting.checkbox.checked = true;
      return setting;
    });
    setSettings(allSelectedSettings);
    // close();
    acceptAllButton.callback(allSelectedSettings);
  };
  const openRegionModal = () => {
    let elem = document.getElementById("cookieSettings");
    if (elem) {
      if (elem.classList.contains("hide-modal")) {
        let regiModalCon = elem.querySelector(".modal-content.grid-story");
        if (!regiModalCon) {
          return false;
        }
        elem.classList.remove("hide-modal");
        elem.classList.add("show-modal");
        document.body.classList.add("show-modal");
        if (elem.scrollTo) {
          elem.scrollTo(0, 0);
        } else {
          elem.scrollTop = 0;
          elem.scrollLeft = 0;
        }
      } else if (elem.classList.contains("show-modal")) {
        elem.classList.add("hide-modal");
        elem.classList.remove("show-modal");
        document.body.classList.remove("show-modal");
      }
    }
  };
  const close = event => {
    if (event) {
      event.preventDefault();
    }

    window.history.replaceState(null, null, window.location.pathname);
    let elem = document.getElementById("cookieSettings");
    if (!elem && document.querySelector(".region-modal")) {
      elem = document.getElementById("jss-model-id");
    }
    if (elem.scrollTo) {
      elem.scrollTo(0, 0);
    } else {
      elem.scrollTop = 0;
      elem.scrollLeft = 0;
    }
    elem.classList.add("hide-modal");
    elem.classList.remove("show-modal");
    document.body.classList.remove("show-modal");
  };
  const saveSettings = () => {
    close();
    saveButton.callback(settings);
  };

  const updateSetting = selectedSetting => {
    const updatedSettings = settings.map(setting => {
      if (setting.checkbox.id === selectedSetting.checkbox.id) {
        setting.checkbox.checked = !setting.checkbox.checked;
      }
      return setting;
    });
    setSettings(updatedSettings);
  };

  return (
    <Modal disabled id="cookieSettings" showModal={showCookieModal} isLong="true">
      <div className="cookie-settings">
        <Heading {...heading} />
        <BodyText {...body} />
        {settings.map((setting, index) => (
          <div className="cookie-setting" key={`cs${index}`}>
            <Heading type={setting.heading.type} typographyClass={setting.heading.typographyClass} html={setting.heading.html} />
            <BodyText {...setting.body} />
            <div className="checkbox-container">
              <Checkbox {...setting.checkbox} onChange={() => updateSetting(setting)} />
            </div>
          </div>
        ))}
        <div className="button-group">
          {acceptAllButton && acceptAllButton.buttonText && <PrimaryButton className="select-all-button" {...{ ...acceptAllButton, callback: () => selectAll() }} />}

          <PrimaryButton className="save-button" {...{ ...saveButton, callback: () => saveSettings() }} />
        </div>
      </div>
    </Modal>
  );
};

CookieSettings.propTypes = {
  heading: PropTypes.shape({
    type: PropTypes.any,
    className: PropTypes.string,
    html: PropTypes.any
  }),
  body: PropTypes.shape({
    html: PropTypes.string
  }),
  sections: PropTypes.array,
  acceptAllButton: PropTypes.shape({
    callback: PropTypes.func,
    icon: PropTypes.shape({ svg: PropTypes.string }),
    colorScheme: PropTypes.any,
    width: PropTypes.string,
    isDisabled: PropTypes.bool,
    internalLink: PropTypes.any,
    transition: PropTypes.any,
    buttonText: PropTypes.string
  }),
  saveButton: PropTypes.shape({
    callback: PropTypes.func,
    icon: PropTypes.shape({ svg: PropTypes.string }),
    colorScheme: PropTypes.any,
    width: PropTypes.string,
    isDisabled: PropTypes.bool,
    internalLink: PropTypes.any,
    transition: PropTypes.any,
    buttonText: PropTypes.string
  })
};

CookieSettings.defaultProps = {
  sections: [],
  modal: {
    disabled: true
  },
  saveButton: { callback: () => {} },
  acceptAllButton: { callback: () => {} }
};

export default CookieSettings;
